export enum ClasseEnum {
  PRIMEIRO_VALOR = 1,
  SEGUNDO_VALOR = 2,
  TERCEIRO_VALOR = 3,
}

export const ClasseEnumDescricao = {
  [ClasseEnum.PRIMEIRO_VALOR]: 'Habeas Corpus',
  [ClasseEnum.SEGUNDO_VALOR]: 'Mandado de Segurança',
  [ClasseEnum.TERCEIRO_VALOR]: 'Agravo de Instrumento',
};

// Exemplo de uso:
export function obterDescricaoEnum(valor: ClasseEnum): string {
  return ClasseEnumDescricao[valor];
}
